import { EGlobalConfig } from '@/enums/cacheEnum'
import { useStorage } from '@/hooks/system/useStorage'
import { defHttp } from '@/utils/http'

function transformData(arr) {
  const lang = useStorage.ls.get(EGlobalConfig.language) || 'CMN'
  const mapping = {
    10: {
      text: 'Match Period',
      t: '_MatchPeriod',
    },
    11: {
      text: 'Match Status',
      t: '_MatchStatus',
    },
    9: {
      text: 'Period',
      t: '_Period',
    },
    12: {
      text: 'Tournament Phase',
      t: '_TournamentPhase',
    },
    8: {
      text: 'Option',
      t: '_Option',
    },
    1: {
      text: 'Sports',
      t: '_Sports',
    },
    7: {
      text: 'MarketType',
      t: '_MarketType',
    },
    21: {
      text: 'Result Type Group',
      t: '_ResultTypeGroup',
    },
  }

  return arr.reduce((acc, item) => {
    const libraryType = mapping[item.libraryType]?.t

    if (libraryType) {
      if (!acc[libraryType]) {
        acc[libraryType] = {}
      }
      acc[libraryType][item.id] = { [lang]: item.text }
    }
    return acc
  }, {})
}

export function fetchSportList(data) {
  return defHttp.post({
    url: '/v1/sport/list',
    data,
  })
}

/** 后端返回的多语言 */
export function fetchLanguage() {
  return defHttp.post({
    url: '/language/static/list',
  }, {
    errorMessageMode: null,
    transformData: (data: any) => {
      return transformData(data)
    },
  })
}
